module.exports = __webpack_public_path__ + "img/ry_5.f010d566.png";